/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 * @reducer
 * Apply For Benefits Reducer.
 * Updates the store with the {@OnlineCategoryModel} object.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import * as ACTIONTYPES from './actionTypes';
/**
 * Updates the online categories details data within the Redux store.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */

function onlineCategoriesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, ACTIONTYPES.APPLY_FOR_BENEFITS_FETCH_ONLINE_CATEGORIES_ACTION_TYPES);
}
/**
 * Updates the error object in the Redux store if there was a problem fetching the
 * online categories from it.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */


function onlineCategoriesErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.APPLY_FOR_BENEFITS_FETCH_ONLINE_CATEGORIES_ACTION_TYPES);
}
/**
 * Sets the intake application type selected by the user on the 'UAApplyForBenefits' store object.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */


function intakeApplicationTypeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: {
      name: ''
    }
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.APPLY_FOR_BENEFITS_SET_INTAKE_APPLICATION_TYPE
  });
}
/**
 * Sets the application programs that were selected in the screen
 * on the 'UAApplyForBenefits' store object.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */


function applicationSelectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.APPLY_FOR_BENEFITS_SET_APPLICATION_SELECTION
  });
}
/**
 * Sets the previous pages on the 'UAApplyForBenefits' store object.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */


function previousPagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.APPLY_FOR_BENEFITS_SET_PREVIOUS_PAGES
  });
}
/**
 * Sets the flag on the 'UAApplyForBenefits' store object that indicates an unauthenticated user
 * is accessing the apply for benefits page and therefore a temporary user will be generated
 * on the fly and logged in behind the scenes. This piece of state will ultimately be used to
 * show a Spinner in the screen.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */


function isTemporaryUserLoggingInReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ACTIONTYPES.APPLY_FOR_BENEFITS_SET_TEMPORARY_USER_LOGGING_IN
  });
}
/**
 * Updates the screening results data within the Redux store.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


function screeningTypeSelectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, ACTIONTYPES.ONLINE_SCREENING_SET_SCREENING_TYPE_SELECTION);
}
/**
 * Updates the flag that is set while the get data request is in progress for the screening results
 * page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


function isFetchingScreeningTypeSelectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.ONLINE_SCREENING_SET_SCREENING_TYPE_SELECTION);
}
/**
 * Updates the get data errors for the screening results page.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


function screeningTypeSelectionErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.ONLINE_SCREENING_SET_SCREENING_TYPE_SELECTION);
}

var reducers = combineReducers({
  onlineCategories: onlineCategoriesReducer,
  onlineCategoriesError: onlineCategoriesErrorReducer,
  applicationTypeDetails: intakeApplicationTypeReducer,
  applicationSelection: applicationSelectionReducer,
  previousPages: previousPagesReducer,
  isTemporaryUserLoggingIn: isTemporaryUserLoggingInReducer,
  screeningTypeSelection: screeningTypeSelectionReducer,
  isFetchingScreeningTypeSelection: isFetchingScreeningTypeSelectionReducer,
  screeningTypeSelectionError: screeningTypeSelectionErrorReducer
});
export default {
  reducers: reducers
};